import o from"styled-components";var p=o("div").withConfig({componentId:"sc-13bppbd-0"})([""]);export{p as Tabs};
